module.exports = __webpack_public_path__ + "static/media/goback.8df404e4.png";